export function setFetching(state, payload) {
  state.fetching = payload;
}
export function setFetched(state, payload) {
  state.fetched = payload;
}

export default { setFetching, setFetched };
